import * as React from 'react';
import { routingEnabled } from 'utils/ui/app';

import DealerEntryWithCallback, { IDealerEntryProps } from './DealerEntry';
import DealerEntryWithRouting from './Container';
import Stream from 'containers/Stream';

const AutoDealerEntry: React.FC<IDealerEntryProps> = (props) => {
  return routingEnabled() ? (
    <DealerEntryWithRouting {...props} />
  ) : (
    <DealerEntryWithCallback {...props}>
      <Stream className="" />
    </DealerEntryWithCallback>
  );
};

export default AutoDealerEntry;
